export const tags = [
  "admin-announcements",
] as const;
